module.exports = "//static.hsappstatic.net/conversations-visitor-experience-components/static-1.595/img/visitor-widget/launcher-open-icon-dark.svg"